export default "__VITE_ASSET__D6h3dWqG__"